import { toastr } from 'react-redux-toastr';
import { I18n } from 'src/translations/i18n';
function getResponseMessage(response) {
    const isRawAxiosResponse = response.data && response.status;
    return isRawAxiosResponse
        ? response?.data?.ResultMsg
        : response?.ResultMsg;
}
export default function toastrSuccess(response, additionalMessage, opts) {
    const message = response && getResponseMessage(response);
    toastr.success(message || I18n.t('Success'), additionalMessage, opts);
}
